// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Customer_invalidDataError__M-+03"};